<script setup lang="ts">
import { RouterLink } from "vue-router";
import { config } from "@/lib/variantConfig";
import {
  Magazine,
  Bookmark,
  MobilePhone,
  Article,
  Home,
  Puzzle,
} from "@/components/icons";
import HelpButton from "@/components/help/HelpButton.vue";
import SidebarCta from "@/components/layout/SidebarCta.vue";
import AppDownloadDialog from "@/components/AppDownloadDialog.vue";
import { DialogRoot, DialogTrigger } from "reka-ui";
import { useAuthStore } from "@/stores/authStore";
import Socials from "@/components/help/Socials.vue";
import DialogContent from "@/components/DialogContent.vue";
import LogoSidebar from "@/components/general/LogoSidebar.vue";

const authStore = useAuthStore();
</script>

<template>
  <aside
    class="fixed top-0 left-0 h-screen bg-background-primary w-72 px-4 pb-4 pt-10 flex flex-col justify-between border-r border-border-secondary"
  >
    <div>
      <RouterLink to="/">
        <LogoSidebar class="w-36" />
      </RouterLink>
      <ul class="flex flex-col gap-2 mt-10">
        <li>
          <RouterLink to="/" class="sidebar-item">
            <Home size="28" />
            <span>{{ $t("menu.home") }}</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/magazines" class="sidebar-item">
            <Magazine size="28" weight="fill" />
            <span>{{ $t("menu.magazines") }}</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/articles" class="sidebar-item">
            <Article size="28" weight="fill" />
            <span>{{ $t("menu.articles") }}</span>
          </RouterLink>
        </li>
        <li v-if="config.puzzle_page?.type === 'web'">
          <RouterLink to="/puzzles" class="sidebar-item">
            <Puzzle size="28" weight="fill" />
            <span>{{ $t("menu.puzzles") }}</span>
          </RouterLink>
        </li>
        <li v-if="authStore.user">
          <RouterLink to="/saved" class="sidebar-item">
            <Bookmark size="28" weight="fill" />
            <span>{{ $t("menu.saved") }}</span>
          </RouterLink>
        </li>
      </ul>
    </div>
    <div class="mt-10">
      <SidebarCta class="mb-2" />
      <DialogRoot>
        <DialogTrigger class="sidebar-item-secondary mb-2">
          <MobilePhone size="28" /><span>{{ $t("menu.download_app") }}</span>
        </DialogTrigger>
        <DialogContent>
          <AppDownloadDialog />
        </DialogContent>
      </DialogRoot>
      <HelpButton />
      <Socials />
    </div>
  </aside>
</template>
